import React from "react";
import Modal from "components/modal";
import { MdDelete, MdClose, MdCheck } from "react-icons/md";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, promotion, loading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width="sm">
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <MdDelete className="h-8 w-8 text-red-500" />
        </div>
        <h3 className="mb-3 text-xl font-semibold text-gray-800">
          Supprimer la promotion
        </h3>
        <div className="mt-4 mb-6">
          <p className="text-gray-600">
            Êtes-vous sûr de vouloir supprimer la promotion{" "}
            <span className="font-bold text-gray-800">{promotion.name_promotion}</span>{" "}
            ?
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Cette action est irréversible.
          </p>
        </div>
        <div className="mt-6 flex justify-center gap-3">
          <button
            type="button"
            className="px-5 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
            onClick={onClose}
            disabled={loading}
          >
            <span className="flex items-center gap-1.5">
              <MdClose className="h-4 w-4" />
              Annuler
            </span>
          </button>
          <button
            type="button"
            className="px-5 py-2 rounded-md bg-red-500 text-white hover:bg-red-600 transition-colors"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center">
                <svg
                  className="-ml-1 mr-2 h-4 w-4 animate-spin text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Chargement...
              </span>
            ) : (
              <span className="flex items-center gap-1.5">
                <MdCheck className="h-4 w-4" />
                Confirmer
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;